// components/ProductList.jsx
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link, Typography } from '@mui/material';

const ProductList = ({ products }) => {
  return (
    <ul className='grid product'>
      {products.map((product, index) => (
        <li key={`${product.product_id}-${index}`}>
          <Link
            component={RouterLink}
            underline="none"
            to={`/products/${product.product_id}`}
            className='product-link'
          >
            <img
              alt={product.product_name || '商品画像'}
              src={
                product.image_url
                  ? `${process.env.REACT_APP_IMAGE_BASE_URL}${product.image_url.replace(/\\/g, '/')}`
                  : `${process.env.REACT_APP_IMAGE_BASE_URL}${process.env.REACT_APP_NOIMAGE}`
              }
              className="product-image"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = `${process.env.REACT_APP_IMAGE_BASE_URL}${process.env.REACT_APP_NOIMAGE}`;
              }}
            />

            <Typography mt={1}>
              {product.product_name}
            </Typography>
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default ProductList;